import { changePasswordError, ChangePasswordError } from "@planzone/dto";
import {
  hasUpperCaseChar,
  hasNumberOrSpecialChar,
  isLongEnough,
  haveMatchingPasswords,
} from "../../entities/passwordValidator";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { findError } from "../../../entities/errorChecker";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (data) => {
    const error: ChangePasswordError = {
      ...changePasswordError,
      doesNotHaveNumberOrSpecialChar: !hasNumberOrSpecialChar(
        data.nextPassword,
      ),
      doesNotHaveUpper: !hasUpperCaseChar(data.nextPassword),
      isTooShort: !isLongEnough(data.nextPassword),
      mismatchedConfirmation: !haveMatchingPasswords(
        data.nextPassword,
        data.passwordConfirmation,
      ),
    };

    return present(
      !findError(error)
        ? repository
            .editPassword(data.account, data.currentPassword, data.nextPassword)
            .then(() => data)
            .catch((error) => Promise.reject({ error, ...data }))
        : Promise.reject({ error, ...data }),
    );
  };
}

export type { Interactor };

export { createInteractor };
